import { Component, OnInit } from "@angular/core";

import { RightSidePanelService } from 'src/shared/providers/providers/right-side-panel';

@Component({
    templateUrl: 'add-credit.html',
    standalone: false
})
export class EmployerAddCreditPage implements OnInit {

  customerId: number | null;

  constructor(
    private rightSidePanelService: RightSidePanelService,
  ) {
    this.customerId = parseInt(localStorage.getItem('customer_id'));
  }

  async ngOnInit() {
    this.rightSidePanelService.setDialogPageTitle('Add Credit');
  }

}
